import ModuleForm from './components/Form';
import Validation from './components/Validation';
new ModuleForm().init();
new Validation().init();